import React from 'react'
import { Form, Input, Button, Space } from 'antd'
import consultantService from '../../services/consultantService'

const AddConsultantForm = ({ form, handleClose, messageApi, messageKey, fetchConsultants }) => {

  const handleAddConsultant = (values) => {
    messageApi.open({
      key: messageKey,
      type: 'loading',
      content: 'Adding consultant...',
      duration: 0
    })
    consultantService.createConsultant(values)
      .then((response) => {
        messageApi.open({
          key: messageKey,
          type: 'success',
          content: 'Consultant successfully added!'
        })
        fetchConsultants()
        handleClose()
      })
      .catch((error) => {
        messageApi.open({
          key: messageKey,
          type: 'error',
          content: 'Error adding consultant!'
        })
      })
  }

  return (
    <Form
      name='add-consultant-form'
      form={form}
      requiredMark={false}
      labelCol={{ span: 7 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      style={{marginTop: 24}}
      onFinish={handleAddConsultant}
    >
      <Form.Item
        label='Name'
        name='userName'
        rules={[{ required: true, message: 'Please enter name' }]}
      >
        <Input type='text'/>
      </Form.Item>
      <Form.Item
        label='Email'
        name='email'
        rules={[{ required: true, message: 'Please enter email' }]}
      >
        <Input type='email'/>
      </Form.Item>
      <Form.Item
        label='Password'
        name='password'
        rules={[{ required: true, message: 'Please enter password' }]}
      >
        <Input.Password minLength={8} />
      </Form.Item>
      <Form.Item
        label='Confirm password'
        name='confirmPassword'
        rules={[{ required: true, message: 'Please confirm password' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The new password that you entered do not match!'));
            },
          }),
        ]}
      >
        <Input.Password minLength={8} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ offset: 7, span: 14 }}
        style={{marginTop: 32}}
      >
        <Space>
          <Button type='primary' htmlType='submit'>Add</Button>
          <Button type='default' onClick={handleClose}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  )
}

export default AddConsultantForm